import React, { useState, useRef } from 'react';
import { Icon } from './Icons';

export default function TagInput({ tags = [], onChange, placeholder = 'Add hashtag, press Enter or Tab...' }) {
  const [input, setInput] = useState('');
  const inputRef = useRef(null);

  const add = (val) => {
    const t = val.trim().toLowerCase().replace(/\s+/g, '-');
    if (t && !tags.includes(t)) {
      onChange([...tags, t]);
    }
    setInput('');
  };

  const remove = (t) => {
    onChange(tags.filter(x => x !== t));
  };

  const onKey = (e) => {
    if (['Enter', ',', ' ', 'Tab'].includes(e.key)) {
      if (input.trim()) {
        e.preventDefault();
        add(input);
      }
    } else if (e.key === 'Backspace' && !input && tags.length) {
      remove(tags[tags.length - 1]);
    }
  };

  return (
    <div
      className="tag-input-wrapper"
      onClick={() => inputRef.current?.focus()}
    >
      {tags.map(t => (
        <span key={t} className="tag-badge removable" onClick={(e) => { e.stopPropagation(); remove(t); }}>
          <span>#{t}</span>
          <span className="tag-remove-x">
            <Icon name="close" size={10} />
          </span>
        </span>
      ))}
      <input
        ref={inputRef}
        className="tag-input-field"
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={onKey}
        onBlur={() => { if (input.trim()) add(input); }}
        placeholder={tags.length === 0 ? placeholder : ''}
      />
    </div>
  );
}